import React from "react";

export default function TourGuideComponent({
  title,
  progress,
  body,
}: {
  title: string;
  progress: string;
  body: string;
}) {
  return (
    <>
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-[#1D2939] text-[16px] font-semibold">{title}</h3>
        <span className="text-[16px] font-medium">{progress}</span>
      </div>
      <p className="text-[#667085] text-justify font-medium text-[14px]">
        {body}
      </p>
    </>
  );
}

export const tourGuideOptions = {
  showProgress: false,
  styles: {
    tooltip: { background: "#ffffff" },
    beaconInner: { background: "#ffffff" },
  },
  placement: "right" as const,
  locale: {
    skip: <span className="text-[#344054]">Skip</span>,
    next: <span className="text-[#ffffff] bg-transparent">Next</span>,
  },
};

export const createTourStep = ({
  target,
  title,
  body,
  progress,
  isLast = false,
  onClick,
}: {
  target: string;
  title: string;
  body: string;
  progress: string;
  isLast?: boolean;
  onClick?: () => void;
}) => ({
  target,
  content: <TourGuideComponent title={title} body={body} progress={progress} />,
  ...tourGuideOptions,
  locale: {
    ...tourGuideOptions.locale,
    ...(isLast && {
      last: (
        <span onClick={onClick} className="text-[#ffffff] bg-transparent">
          Finish up
        </span>
      ),
    }),
  },
});
